<template>
  <div class="d-flex justify-content-center align-items-start py-5 bg-light" style="min-height: calc(100vh - 56px);">
    <div class="card shadow-sm border-0" style="max-width: 480px; width: 100%;">
      <div class="card-body text-center p-4">
        <i class="fas fa-lock text-danger mb-3" style="font-size: 2.5rem;"></i>
        <h4 class="card-title mb-2">Access denied</h4>
        <p class="text-muted mb-4">
          Your account does not have permission to view this page. If you
          believe this is a mistake, ask an administrator to update your role.
        </p>
        <div class="d-flex justify-content-center gap-2">
          <router-link to="/" class="btn btn-outline-primary">
            <i class="fas fa-wallet me-1"></i> Go to Portfolio
          </router-link>
          <button class="btn btn-outline-secondary" @click="logout">
            <i class="fas fa-sign-out-alt me-1"></i> Log out
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useAuth } from '../composables/useAuth'

export default {
  name: 'Forbidden',
  setup() {
    const { logout } = useAuth()
    return { logout }
  }
}
</script>
